export const Survey = {
  "NPS": {
    "title": "Help Us Improve Foxit PDF Editor Cloud",
    "Submit": "Submit",
    "NotLikely": "Not likely",
    "VeryLikely": "Very likely",
    "TellUs": "Tell us your ideas......",
    "subjects": {
      "1": "How likely are you to recommend Foxit PDF Editor to others?",
      "2": "What would make you more likely to recommend Foxit PDF Editor Cloud to others? (Optional)"
    },
    "thanks": {
      "content": "Thank you for taking the time to provide us with feedback",
      "SubContent": "We will use it to improve the product."
    },
    "contactLabel": "I'm open to being contacted to give additional feedback to help improve the product."
  }
}